import { render, staticRenderFns } from "./ChevronFat.vue?vue&type=template&id=a15b7a66&scoped=true"
import script from "./ChevronFat.vue?vue&type=script&lang=js"
export * from "./ChevronFat.vue?vue&type=script&lang=js"
import style0 from "./ChevronFat.vue?vue&type=style&index=0&id=a15b7a66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a15b7a66",
  null
  
)

export default component.exports